import type { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiTableContainer: Components<CssVarsTheme>['MuiTableContainer'] = {
  styleOverrides: {
    root: {
      position: 'relative',
      border: 'none'
    }
  }
};

export const MuiTableRow: Components<CssVarsTheme>['MuiTableRow'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-selected': {
        backgroundColor: theme.vars.palette.action.selected,
        '&:hover': {
          backgroundColor: theme.vars.palette.action.hover
        }
      }
    })
  }
};

export const MuiTableCell: Components<CssVarsTheme>['MuiTableCell'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderLeft: `1px solid ${theme.vars.palette.divider} !important`,
      borderBottom: `1px solid ${theme.vars.palette.divider} !important`,
      fontSize: 13
    }),
    body: {
      minHeight: 0,
      padding: '4px !important'
    },
    head: ({ theme }) => ({
      wordWrap: 'break-word',
      fontSize: 13,
      color: '#fff',
      fontWeight: 600,
      backgroundColor: `${theme.vars.palette.primary.main} !important`,
      borderLeft: '1px solid #fff !important',
      ':first-of-type': {
        borderLeft: 'none !important',
        borderTopLeftRadius: 8
      },
      ':last-of-type': {
        paddingTop: 0,
        borderTopRightRadius: 8
      }
    }),
    stickyHeader: {
      backgroundColor: '#FFFFFF',
      backgroundImage: 'linear-gradient(to bottom, #F4F6F8 0%, #F4F6F8 100%)'
    },
    paddingCheckbox: {
      paddingLeft: '8px'
    }
  }
};
